import { useCallback } from 'react';
import toast from 'react-hot-toast';

export const useClipboard = (
  onPaste = (items) => {
    console.log('onPaste', items);
  },
) => {
  const handlePaste = useCallback(async (event) => {
    if (!event?.clipboardData) return null;

    console.log('event', event);
  
    const { items: pastedItems } = event.clipboardData;

    const creatingItems = [];

    // const items = await clipboardRead();
    if (!pastedItems.length) return;

    const text = event.clipboardData.getData('text/plain');

    console.log('text', text);

    if (text) { 
      // Handle text from clipboard
      const blob = new Blob([text.trim()], { type: 'text/plain' });
      creatingItems.push(blob);
    } else { 
      // Handle images from clipboard
      for (const item of pastedItems) {
        console.log('pasted item', item);
        // It's possible to handle other types of items here, like files, videos, etc.
        if (item.kind === 'file' && item.type.startsWith('image/')) {
          console.log('pasted image', item);
          const file = item.getAsFile();
          if (!file) continue;
          creatingItems.push(file);
        }
      }
    }

    console.log('pastedItems', creatingItems);

    onPaste(creatingItems);
  }, [onPaste]);

  const clipboardRead = useCallback(async () => {
    try {
      if (!navigator.clipboard || typeof navigator.clipboard.read !== 'function') {
        toast.error('Clipboard read not supported');
      }

      const clipboardItems = await navigator.clipboard.read();

      let creatingItems = [];

      // Prefer images
      for (const item of clipboardItems) {
        const imageType = item.types?.find((t) => t.startsWith('image/'));
        if (imageType) {
          const imageBlob = await item.getType(imageType);
          if (imageBlob) {
            creatingItems.push(imageBlob);
          }
        }
      }

      // Otherwise use plain text blob if present
      for (const item of clipboardItems) {
        if (item.types?.includes('text/plain')) {
          const textBlob = await item.getType('text/plain');
          if (textBlob && textBlob.size > 0) {
            creatingItems.push(textBlob);
          }
        }
      }

      onPaste(creatingItems);
    } catch (error) {
      console.error('Failed to paste from clipboard:', error);
      if (error.name === 'NotAllowedError') {
        toast.error('Clipboard access denied. Please grant permission.');
      } else {
        toast.error('Failed to paste from clipboard');
      }
    }
  }, [onPaste]);

  const clipboardWrite = useCallback(async (items) => {
    if (!navigator.clipboard || typeof navigator.clipboard.write !== 'function') {
      toast.error('Clipboard write not supported');
    }
    await navigator.clipboard.write(items);
  }, []);

  return {
    handlePaste,
    clipboardRead,
    clipboardWrite
  };
};